module.exports = "<task-detail-menu task=\"$ctrl.task\" class=\"task-detail-menu task-detail__side-menu\"></task-detail-menu>\n\n<div class=\"task-detail__content\" ui-view ></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/engineer/screens/tasks/screens/task-detail/task-detail.html
// module id = 358
// module chunks = 0